import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Building2, ArrowLeft } from "lucide-react";
import { API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err, "Link non valido o scaduto"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 shadow-sm fade-in">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-lg bg-blue-800 flex items-center justify-center">
            <Building2 className="h-5 w-5 text-white" />
          </div>
          <h1 className="font-heading text-xl font-extrabold tracking-tight text-slate-900">Nuova password</h1>
        </div>
        {!token ? (
          <div data-testid="reset-password-invalid">
            <p className="text-sm text-red-600 mb-4">Link non valido: token mancante.</p>
            <Link to="/login" className="text-sm text-blue-800 hover:underline flex items-center gap-1" data-testid="back-to-login-link">
              <ArrowLeft className="h-4 w-4" /> Torna al login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
            <div className="space-y-2">
              <Label htmlFor="password">Nuova password</Label>
              <Input
                id="password"
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Minimo 8 caratteri"
                data-testid="reset-password-input"
              />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="reset-password-error">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full bg-blue-800 hover:bg-blue-900" data-testid="reset-password-submit-button">
              {loading ? "Salvataggio..." : "Reimposta password"}
            </Button>
            <Link to="/login" className="text-sm text-blue-800 hover:underline flex items-center gap-1 justify-center" data-testid="back-to-login-link">
              <ArrowLeft className="h-4 w-4" /> Torna al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
